import { Form, Radio, FormProps, Popover, PopoverProps, Tooltip, Select } from 'antd';
import { useEffect, useState } from 'react';
import { css } from '@emotion/css';
import styled from '@emotion/styled';
import ReceptionMinuteSelect from 'components/ReceptionMinuteSelect';
import { T, useTranslate } from '@tolgee/react';

const { Item: FormItem } = Form;
const { Group: RadioGroup } = Radio;

const LooseRadio = styled(Radio)`
  margin: 8px 0;
`;

const H6 = styled.h6`
  font-weight: 600;
  font-size: 14px;
`;
const P = styled.p`
  font-size: 12px;
  color: #84868c;
`;
const ReceptionMinuteSelectClassName = css`
  margin: 8px 10px 8px 24px;
`;

const X = (props: Parameters<typeof ReceptionMinuteSelect>[0]) => {
  const { children, ...otherProps } = props;

  return (
    <FormItem noStyle name="minutes">
      <ReceptionMinuteSelect {...otherProps} />
    </FormItem>
  );
};

export interface AiReceptionFormProps
  extends FormProps<{
    paused: boolean;
    minutes: number;
  }> {
  endTimeStr?: string;
}

const AiReceptionForm = (props: AiReceptionFormProps) => {
  const { endTimeStr, ...formProps } = props;
  const { t } = useTranslate();
  const { initialValues } = formProps;
  const initialPaused = initialValues?.paused;
  return (
    <>
      <H6>{t('aiReceptionForm.启用智能客服')}</H6>
      <P>{t('aiReceptionForm.AI回复在暂停期间，可点击[启用AI回复]启用')}</P>
      <Form {...formProps}>
        <FormItem name="paused" noStyle>
          <RadioGroup>
            <LooseRadio value={false}>{t('aiReceptionForm.启用AI回复')}</LooseRadio>
            {/* eslint-disable-next-line react/jsx-boolean-value */}
            <LooseRadio value={true}>{t('aiReceptionForm.暂停AI回复')}</LooseRadio>
          </RadioGroup>
        </FormItem>
        <FormItem noStyle dependencies={['paused']}>
          {({ isFieldsTouched, getFieldValue }) => {
            const dirty = isFieldsTouched();
            const isPuased = getFieldValue('paused');
            const showCountDown = initialPaused && !dirty;
            return (
              <>
                {showCountDown ? (
                  <Select
                    className={ReceptionMinuteSelectClassName}
                    size="small"
                    optionLabelProp="label"
                    options={[{ label: endTimeStr, value: 'paused' }]}
                    value="paused"
                    disabled
                  />
                ) : (
                  <T
                    keyName="aiReceptionForm.x后自动开启"
                    params={{
                      comx: (
                        <X
                          className={ReceptionMinuteSelectClassName}
                          disabled={!isPuased || !dirty}
                          size="small"
                        />
                      ),
                    }}
                  />
                )}
              </>
            );
          }}
        </FormItem>
      </Form>
    </>
  );
};
export default AiReceptionForm;

const Footer = styled.div`
  margin-top: 8px;
`;

export const AiReceptionPopoverForm = (
  props: PopoverProps & {
    formProps: AiReceptionFormProps;
    isPaused: boolean;
  },
) => {
  const { formProps, isPaused, visible: popVisible, content, ...otherProps } = props;
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const { t } = useTranslate();
  useEffect(() => {
    if (popVisible) {
      setTooltipVisible(false);
    }
  }, [popVisible]);
  return (
    <Tooltip
      title={isPaused ? t('aiReceptionForm.AI回复已暂停') : t('aiReceptionForm.AI回复已启用')}
      visible={tooltipVisible}
      onVisibleChange={(v) => {
        setTooltipVisible(!popVisible && v);
      }}
    >
      <Popover
        trigger="click"
        visible={popVisible}
        content={
          <div style={{ width: '208px' }}>
            <AiReceptionForm {...formProps} />
            <Footer>{content}</Footer>
          </div>
        }
        {...otherProps}
      />
    </Tooltip>
  );
};
